import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "rounded shadow-lg modal-content-container" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "text-center fw-bold" }, "Axxess Central", -1 /* HOISTED */)
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: null }, "-- Select Organization --", -1 /* HOISTED */)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "mt-1 d-flex px-3 justify-content-center" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select ps-1 my-4",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOrganization) = $event))
        }, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizationsList, (organization) => {
            return (_openBlock(), _createElementBlock("option", {
              value: organization,
              key: organization
            }, _toDisplayString(organization.name), 9 /* TEXT, PROPS */, _hoisted_6))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */), [
          [_vModelSelect, _ctx.selectedOrganization]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel())),
          type: "button",
          class: "btn btn-xs me-2 btn-outline-primary py-2 px-4"
        }, " Cancel "),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ok())),
          type: "button",
          disabled: _ctx.organizationsList.length == 0,
          class: "btn btn-xs btn-primary py-2 px-4"
        }, " Enter ", 8 /* PROPS */, _hoisted_8)
      ])
    ])
  ]))
}